import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import FormField from './FormField';
import DropdownField from './DropdownField';

class CurrencySelector extends Component {
  static propTypes = {
    currencies: PropTypes.array.isRequired,
    currentCurrency: PropTypes.object,
    formErrors: PropTypes.object.isRequired,
  }

  static defaultProps = {
    currentCurrency: null,
  }

  componentDidMount() {
    this.presetVisibility(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.presetVisibility(nextProps);
  }

  presetVisibility(props) {
    if (props.formErrors.has('currency')) {
      this.setState(() => ({ inputVisible: true }));
    }
  }

  state = {
    inputVisible: false,
  }

  toggleInput = () => this.setState((previous) => ({ inputVisible: !previous.inputVisible }));

  render() {
    let ValueComponent = ({ item }) => (
      <div>
         <FlagComponent item={item.value || ''} />
         <strong>{item.value}</strong>
       </div>
    );

     let FlagComponent = ({ item }) => (
       <div className={'currency-flag currency-flag-' + item.toLowerCase()}></div>
     );

    return (
      <div className="form-group">
        <div className="row align-items-center no-gutters">
          <div className="col text-left">
            <FormField
              label={this.props.label}
              name={this.props.name}
              component={DropdownField}
              error={this.props.error}
              inputProps={
                {
                  valueField: 'id',
                  textField: 'name',
                  valueComponent: ValueComponent,
                  itemComponent: ValueComponent,
                  ...this.props.inputProps,
                }
              }
              data={this.props.currencies}
              type="text"
              className="form-control"
              placeholder="Select currency"
              clearMargin={true}
              required
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CurrencySelector;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/CurrencySelector.jsx